import { useFloorReturn } from "@/lib/floorReturn";
import { Warehouse } from "lucide-react";
import { KeyboardAwareBottomBar } from "@/components/KeyboardAwareBottomBar";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

// The single, clean exit from a desk screen a Floor tech linked into. One big button.
// Only prompts when there is genuinely unsaved work at risk (fr.dirty) — never on a
// clean exit. Returns to Floor Home; preferred_surface is never changed. The exit logic
// lives in the FloorReturn context so the header logo + header back button share it.
// The bar rides on KeyboardAwareBottomBar so it never covers a control while the tablet
// keyboard is up (the header "← Floor" button stays available as the exit in that window).
export function FloorReturnBar() {
  const fr = useFloorReturn();

  return (
    <>
      <KeyboardAwareBottomBar testid="floor-return-bar"
        className="bg-white/95 backdrop-blur border-t-2 border-[#B01E28] p-3">
        <button type="button" onClick={() => fr?.exitToFloor()} data-testid="floor-return-done"
          className="w-full max-w-2xl mx-auto flex items-center justify-center gap-2.5 h-14 rounded-xl bg-[#0F172A] text-white font-black text-lg active:scale-[0.99] transition-transform duration-100">
          <Warehouse className="w-6 h-6" /> Done — Back to Floor
        </button>
      </KeyboardAwareBottomBar>

      <AlertDialog open={!!fr?.confirmOpen} onOpenChange={fr?.setConfirmOpen}>
        <AlertDialogContent data-testid="floor-return-unsaved-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Leave with unsaved work?</AlertDialogTitle>
            <AlertDialogDescription>
              You have changes on this screen that haven’t been saved yet. Going back to the
              Floor now will discard them.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <Button variant="outline" onClick={() => fr?.setConfirmOpen(false)} data-testid="floor-return-stay">Stay &amp; finish</Button>
            <Button className="bg-[#B01E28] hover:bg-[#8f1820] text-white" onClick={() => fr?.doExit()} data-testid="floor-return-leave">Leave anyway</Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
